//Styles
import devToolStyles from "../../styles/developerTools/DevTools.module.css"

export default function DevRoleSwitcher({ expandedCode, onSetExpandedCode }) {
  const cardCode = "RoleSwitcher"

  return (
    <div
      className={`${devToolStyles.cardLayout} ${
        expandedCode === cardCode ? devToolStyles.cardLayoutExpanded : ""
      } ${
        expandedCode !== "" && expandedCode !== cardCode
          ? devToolStyles.cardLayoutHidden
          : ""
      }`}
      onClick={() => {
        onSetExpandedCode(cardCode)
      }}
    >
      <div className={devToolStyles.cardLayoutTitle}>Role switcher (TBC)</div>
      <div className={devToolStyles.cardLayoutStatus}></div>
      <div className={devToolStyles.cardLayoutDescription}>
        Switch user roles
      </div>
      <div className={devToolStyles.cardLayoutBody}>
        This functionality is not implemented and serves as a placeholder for
        future tools
      </div>
    </div>
  )
}
